import React, { useEffect } from 'react';

// assets

// services
import DataCountryService from '../../../../../services/data/geographics/country';

// props
import { IDataCountryResourceShortProps } from '../../../../../props/data/geographics/countries';

// components
import { Dropdown, DropdownMenuItemType, IDropdownOption, SpinnerSize, Stack } from '@fluentui/react';
import Label from '../../../../typography/label';
import LoadingComponent from '../../../../feedbacks/loading';
import { IDataVesselCrewRoleResourceShortProps } from '../../../../../props/data/vessels/crew';
import DataVesselCrewRoleService from '../../../../../services/data/vessels/crewRole';

type SelectVesselCrewRoleProps = {
    key?: string;
    selected?: IDataVesselCrewRoleResourceShortProps;
    options?: IDataVesselCrewRoleResourceShortProps[];
    qs?: string[];
    label?: string;
    hideLabel?: boolean;
    required?: boolean;
    disabled?: boolean;
    allowCreate?: boolean;
    onChange(selected?: IDataVesselCrewRoleResourceShortProps): void;
}

const SelectVesselCrewRole: React.FC<SelectVesselCrewRoleProps> = (props: SelectVesselCrewRoleProps) => {
    const [activeSurface, setActiveSurface] = React.useState<string | undefined>();
    const [selected, setSelected] = React.useState<IDataVesselCrewRoleResourceShortProps | undefined>();
    const [loaded, setLoaded] = React.useState<boolean>(false);
    const [options, setOptions] = React.useState<IDataVesselCrewRoleResourceShortProps[]>([]);

    useEffect(() => {
        setSelected(props.selected);
    }, [props.selected]);

    useEffect(() => {
    }, [props]);

    useEffect(() => {
        init();
    }, []);

    const init = async () => {
        if (props.options) {
            setOptions(props.options);
        } else {
            let _roles = await DataVesselCrewRoleService.retrieve();
            _roles = _roles.sort((a, b) => (a.orderNumber > b.orderNumber) ? 1 : ((b.orderNumber > a.orderNumber) ? -1 : 0))
            setOptions(_roles);
        }
        setLoaded(true);
    }

    const groupOptions = (_options: IDataVesselCrewRoleResourceShortProps[]) => {
        const groups: {name: string, items: IDataVesselCrewRoleResourceShortProps[]}[] = [];
        
        _options.forEach((opt) => {
            const idx = groups.findIndex((g) => g.name.toLowerCase() === (opt.group || "").toLowerCase());
            if (idx > -1) {
                groups[idx].items.push(opt);
            } else {
                groups.push({name: opt.group || "Others", items: [opt]});
            }
        });

        return groups;
    }

    const getDropdownOptions = (_options: IDataVesselCrewRoleResourceShortProps[]) => {
        const groups = groupOptions(_options);
        const dropdownOptions: IDropdownOption[] = [];

        groups.forEach((group, idx) => {
            if (idx > 0) {dropdownOptions.push({key: 'divider_' + idx, text: "", itemType: DropdownMenuItemType.Divider});}
            dropdownOptions.push({key: 'group_' + idx, text: group.name, itemType: DropdownMenuItemType.Header});

            group.items.forEach((item) => {
                dropdownOptions.push({key: item.id, text: item.name});
            })
        });

        return dropdownOptions;
    }

    return <Stack>
        {props.hideLabel ? null : <Label style={{ padding: '3px 0px' }} size={'xsmall'} required={props.required}>{props.label || "Country"}</Label>}
        <Stack tokens={{childrenGap: 3}}>
            <Stack horizontal tokens={{ childrenGap: 10 }} verticalAlign={'center'} styles={{root: {width: '100%'}}}>
                {!loaded ? <LoadingComponent label={""} size={SpinnerSize.small} /> : null}
                <Stack styles={{root: {width: '100%'}}}>
                    <Dropdown key={props.key} disabled={props.disabled || !loaded}
                        selectedKey={selected?.id}
                        options={getDropdownOptions(options)}
                        onChange={(evt, opt) => {
                            const selected = options.find((o) => o.id === opt?.key as string);
                            props.onChange(selected);
                        }} />
                </Stack>
            </Stack>
        </Stack>
    </Stack>;
};

export default SelectVesselCrewRole;
